<template>
  <b-modal
      id="update-share-advocate"
      :title="_.get(shareRecord, 'sadvocate.name') + ' shared with ' + _.get(shareRecord, 'sgroup.groupName')"
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="showModal"
      centered
    >
    <b-row>
      <b-col>
        <br>
        <b>Created At: </b> {{ $moment.unix(_.get(shareRecord, 'createdAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <br>
        <b>Last Updated: </b> {{ $moment.unix(_.get(shareRecord, 'updatedAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <br>
        <b>Current Status: </b> {{ _.get(shareRecord, 'advocateShareStatus', false) ? 'Shared' : 'Not Shared' }}
        <br>
      </b-col>
    </b-row>
    <div slot="modal-footer" class="w-100"></div>
  </b-modal>
</template>

<script>
export default {
  name: 'update-share-advocate-modal',
  props: {
    advocateId: Number,
    advocateOrganizationOwner: Number,
    shareRecord: Object,
    showModal: Boolean
  },
  computed: {
    isShared: function () {
      return _.get(this.shareRecord, 'advocateShareStatus', false)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Share/UpdateShareAdvocateModal.vue